import React, { FC, useContext } from 'react';
import { codes } from '../../data/translations';
import { TranslationContext } from '../../modules/translations';

const getCode = (keyCode: string) => {
	switch (keyCode) {
		case 'is required':
		case 'Required':
			return codes.required;

		case 'lessThanOrEqualTo':
			return codes.common.maxNumber;

		case 'greaterThanOrEqualTo':
			return codes.common.minNumber;

		case 'maximum length exceeded':
			return codes.common.maximumLengthExceeded;

		case 'FILE_UPLOADER_NAME_IS_INVALID':
			return codes.common.wrongFileName;

		case 'length is less than required':
			return codes.common.lengthIsLessThanRequired;

		case 'invalidEmail':
			return codes.common.wrongEmailPleaseTryAgain;

		case 'dateAcross':
			return codes.common.endDateValidationMessage;

		case 'dropdownAcross':
			return codes.common.dropdownItemsOverlapMessage;

		case 'defaultLanguageValueRequired':
			return codes.common.defaultLanguageValueRequired;

		case 'clockwiseVerticalValidation':
			return codes.timeCards.shouldBeEqualOrLessThan;

		case 'wrongTimeFormat':
			return codes.dateTime.wrongTimeFormat;

		case 'wrongCurrencyFormat':
			return codes.common.wrongCurrency;

		case 'expected format: dd-mm-yyyy':
		case 'is not a valid date':
			return codes.dateTime.wrongDateFormat;

		case 'notAnInteger':
		case 'notANumber':
			return codes.common.notANumber;

		case 'invalidValue':
		case 'should be >= 01-01-1970':
		case 'should be <= 01-01-2100':
			return codes.common.invalidValue;

		case 'wrong hex format':
			return codes.common.wrongHexFormat;

		case 'invalidUrl':
			return codes.common.invalidUrl;
		case 'protocolRequired':
			return codes.common.urlProtocolRequired;

		default:
			return 'STRING_LITERAL';
	}
};

type ValidationMessageProps = {
	keyCode: string;
};

export const ValidationMessage: FC<ValidationMessageProps> = ({ keyCode }) => {
	const { translate } = useContext(TranslationContext);
	const translationCode = getCode(keyCode);

	switch (translationCode) {
		//ready translations string
		case 'STRING_LITERAL':
			return <>{keyCode}</>;

		default:
			return <>{translate(translationCode)}</>;
	}
};
